import React, {forwardRef} from 'react'
import tw from 'tailwind-styled-components'
import {DivWithHint} from '@components/common/hint/hint'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'
import {cn} from '@containers/html-utils'
import {colorTextClass} from '../design-system'
import {IconProps, TwProps} from './types'

export type {IconProps}

export const getSize = (size: IconProps['size']): string => {
  return size ? `w-${size} h-${size}` : ''
}

const TwIcon = tw(DivWithHint)<TwProps>`
  flex
  items-center
  justify-center
  select-none
  ${p => cn(colorTextClass(p.$color), getSize(p.$size))}
`

const isReactNode = (node: any): node is React.ReactNode => {
  return typeof node === 'object' && node !== null
}

export const Icon = forwardRef<HTMLDivElement, IconProps>(
  ({color, size, icon, type, title, hint, className, style, onClick}, ref) => (
    <TwIcon
      ref={ref}
      $size={size ?? 16}
      $color={color ?? 'grey'}
      // `span` instead of `div` to allow using inside other inline elems w/o warnings
      componentTag="span"
      title={title}
      content={hint}
      className={className}
      style={style}
      onClick={onClick}
    >
      {isReactNode(icon) ? (
        icon
      ) : (
        <IconTabler
          customSize={size}
          icon={icon}
          type={type}
          viewBox="0 0 24 24"
        />
      )}
    </TwIcon>
  )
)
